import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "PIRLSGAIN",
  title: defineMessage({
    id: "fig.learning.PIRLSGAIN.title",
    defaultMessage: `Percentage of Grade 8 students above the TIMSS Intermediate International Benchmark`,
  }),
  caption: defineMessage({
    id: "fig.learning.PIRLSGAIN.caption",
    defaultMessage: `In many countries, progress in improving learning is slow or even stagnant, but rapid progress is possible.`,
  }),
  source: defineMessage({
    id: "fig.learning.PIRLSGAIN.source",
    defaultMessage: `TIMSS surveys`,
  }),
};
